requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('time-countdown')) {
      class TimeCountdown extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.timer = this.querySelector('.time-countdown__timer');
          this.timerPrefix = this.querySelector('.time-countdown__timer-prefix');
          this.finalDate = null;

          if (this.dataset.dateUnix) {
            const unix = parseInt(this.dataset.dateUnix, 10);
            if (!Number.isNaN(unix)) {
              this.finalDate = new Date(unix * 1000);
            }
          }

          if (!this.finalDate || Number.isNaN(this.finalDate.getTime())) {
            this.finalDate = new Date(this.dataset.date);
          }

          if (!this.finalDate || Number.isNaN(this.finalDate.getTime())) {
            if (!window.Shopify.designMode) {
              (this.timerPrefix ? this.timer : this).classList.add('hidden');
            }

            return;
          }

          this.lastTime = {};
          this.start();
        }

        start() {
          if (!this.checkOverdueDate()) {
            if (!window.Shopify.designMode) {
              (this.timerPrefix ? this.timer : this).classList.add('hidden');
            }

            return;
          }

          this.display();
          this.inrerval = setInterval(() => this.display(), 1000);
        }

        display() {
          this.render(this.getRemainingTime());
          (this.timerPrefix ? this.timer : this).classList.remove('hidden');
        }

        checkOverdueDate() {
          if (this.getTotal() < 0) {
            if (this.dataset.refreshDailyMode === 'true') {
              while (this.getTotal() < 0) {
                this.finalDate = new Date(this.finalDate.getTime() + 86400000);
              }
              return true;
            }

            if (this.inrerval) {
              clearInterval(this.inrerval);
            }
            return false;
          } else {
            return true;
          }
        }

        getTotal() {
          return Date.parse(this.finalDate) - Date.parse(new Date());
        }

        getRemainingTime() {
          if (!this.checkOverdueDate()) {
            return false;
          }

          const total = this.getTotal();
          const seconds = Math.floor((total / 1000) % 60);
          const minutes = Math.floor((total / 1000 / 60) % 60);
          const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
          const days = Math.floor(total / (1000 * 60 * 60 * 24));

          return {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
          };
        }

        render(time) {
          if (!time) {
            this.parentNode.classList.add('hidden');
            return;
          }

          let html = '';

          html += this.buildSectionHTML(time.days, window.variantStrings.countdown.days, time.days !== this.lastTime.days);
          html += this.buildSectionHTML(time.hours, window.variantStrings.countdown.hours, time.hours !== this.lastTime.hours, time.days, true, !!time.days);
          html += this.buildSectionHTML(time.minutes, window.variantStrings.countdown.minutes, time.minutes !== this.lastTime.minutes, time.hours, true, true);
          html += this.buildSectionHTML(time.seconds, window.variantStrings.countdown.seconds, time.seconds !== this.lastTime.seconds, time.minutes, true, true);

          this.timer.innerHTML = html;
          this.lastTime = time;
        }

        buildSectionHTML(time, postfix, wasChanged, showZero, addZeroToSingle) {
          if (!time && !showZero) return '';

          let timeToString = time.toString();

          if (!time && showZero) timeToString = '0';
          if (addZeroToSingle === true && time < 10) timeToString = `0${timeToString}`;

          return `<span class="time-countdown__section ${wasChanged ? 'js-pulse' : ''}">
                            <span class="time-countdown__time">${timeToString}</span>
                            <span class="time-countdown__postfix">${postfix}</span>
                            </span>
                            <span class="time-countdown__break">&nbsp;:&nbsp;</span>`;
        }

        disconnectedCallback() {
          if (this.inrerval) clearInterval(this.inrerval);
        }
      }

      customElements.define('time-countdown', TimeCountdown);
    }
  });
});